import { FC } from 'react';

import { Box, Card, Link, Typography } from '@mui/material';

import { useQuery } from 'react-query';
import { useRecoilValue } from 'recoil';

import { CompanyDetailSaleCases, useSaleCase } from '@hooks_iqfu/dashboard/useSaleCase';

import { companyLoginUserDataSelector } from '@recoil_iqfu/atoms/auth/companyLoginUserData';

import { registerLinkStyle, infoContainerStyle, infoStyle, titleStyle } from './DashbordSaleCasesStyles';
import SaleCasesMap from './SalesCaseMap';

type Props = {};

const pageLabel = 'companies_detail';

const DashboardSaleCases: FC<Props> = () => {
  const { companyId, isMultipleCompanyUser } = useRecoilValue(companyLoginUserDataSelector);
  const { getSaleCasesList } = useSaleCase();

  const { data: companyDetailSaleCases, isLoading } = useQuery<CompanyDetailSaleCases | undefined>(
    ['getSaleCasesList', companyId],
    () => (companyId ? getSaleCasesList(Number(companyId)) : undefined),
    { enabled: !!companyId && !isMultipleCompanyUser },
  );
  const isGeneralAgency = companyDetailSaleCases?.company_type === 'general_agency';
  const label = isGeneralAgency ? '売却' : '買取';
  const registerLinkText = `${isGeneralAgency ? '売却' : ''}実績登録はこちら`;
  const headingText = `${label}実績登録`;
  const descriptionTexts = isGeneralAgency
    ? [
        'サイト内の市区町村別ランキングは、売却実績の登録数と実績の新しさで、上位表示される仕様となっております。',
        '今後も継続して実績をご登録ください。',
      ]
    : [
        '取引タイプを「自社買取」「買取会社への仲介」で登録した物件の金額や詳細は',
        'お客様が見るページに表示はされません。',
      ];

  if (isLoading || isMultipleCompanyUser || !companyDetailSaleCases) {
    return null;
  }

  return (
    <Card sx={{ mt: 2, p: 2 }}>
      <Typography sx={titleStyle}>{headingText}</Typography>
      <Box sx={{ width: '100%', height: '400px', mt: 2 }}>
        <SaleCasesMap
          pageKey={`${pageLabel}${companyId}`}
          mapType="company_detail"
          lat={companyDetailSaleCases.lat}
          long={companyDetailSaleCases.long}
          zoom={12}
          mapBounds={companyDetailSaleCases.sale_case_map_bounds}
          companyDetailSaleCasesMapPinList={companyDetailSaleCases.sale_case_map_pins}
          fitBounds
          companyLocation={{ long: companyDetailSaleCases.long, lat: companyDetailSaleCases.lat }}
        />
      </Box>
      <Typography sx={registerLinkStyle}>
        貴社が過去に{label}された
        <Link href={`/console/company/sale_cases/create`}>
          <a style={{ color: '#3D5DA2', fontSize: '2rem', textDecoration: 'underline' }}>{registerLinkText}</a>
        </Link>
      </Typography>
      <Box sx={infoContainerStyle}>
        {descriptionTexts.map((text, idx) => (
          <Typography key={idx} sx={infoStyle}>
            {text}
          </Typography>
        ))}
      </Box>
    </Card>
  );
};

export default DashboardSaleCases;
